export interface Language {
  readonly id: string;
  readonly name: string;
}

export function getLanguage(id: string): Language | undefined {
  return ALL_LANGUAGES.find((l) => l.id.toLowerCase() === id.toLowerCase());
}

export function getLanguageName(id: string): string {
  const language = getLanguage(id);

  return language?.name || 'unknown';
}

export const ALL_LANGUAGES: readonly Language[] = [
  {
    id: 'en-US',
    name: 'English (United States)',
  },
  {
    id: 'en-GB',
    name: 'English (United Kingdom)',
  },
  { id: 'de-DE', name: 'Deutsch (Deutschland)' },
  { id: 'fr-FR', name: 'Français (France)' },
  { id: 'es-AR', name: 'Español (Argentina)' },
  { id: 'es-BO', name: 'Español (Bolivia)' },
  { id: 'es-CL', name: 'Español (Chile)' },
  { id: 'es-CO', name: 'Español (Colombia)' },
  { id: 'es-CR', name: 'Español (Costa Rica)' },
  { id: 'es-DO', name: 'Español (República Dominicana)' },
  { id: 'es-EC', name: 'Español (Ecuador)' },
  { id: 'es-SV', name: 'Español (El Salvador)' },
  { id: 'es-GQ', name: 'Español (Guinea Ecuatorial)' },
  { id: 'es-GT', name: 'Español (Guatemala)' },
  { id: 'es-HN', name: 'Español (Honduras)' },
  { id: 'es-MX', name: 'Español (México)' },
  { id: 'es-NI', name: 'Español (Nicaragua)' },
  { id: 'es-PA', name: 'Español (Panama)' },
  { id: 'es-PY', name: 'Español (Paraguay)' },
  { id: 'es-PE', name: 'Español (Perú)' },
  { id: 'es-PR', name: 'Español (Puerto Rico)' },
  { id: 'es-ES', name: 'Español (España)' },
  { id: 'es-US', name: 'Español (Estados Unidos)' },
  { id: 'es-UY', name: 'Español (Uruguay)' },
  { id: 'es-VE', name: 'Español (Venezuela)' },
  {
    id: 'pt-BR',
    name: 'Português (Brasil)',
  },
];
